import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  // strict: true,
  state: {
    cost: 0,
    data: {
      projectType: "",
      homeType: "",
      squareMeters: 0,
      rooms: {
        kitchen: 0,
        dining: 0,
        living: 0,
        bathroom: 0,
        bedroom: 0,
        hallway: 0,
        staircase: 0,
        wellness: 0,
        gym: 0,
        basement: 0,
        office: 0,
        storage: 0,
        garage: 0,
        other: 0
      },
      buttons: "",
      displays: 0,
      voiceControl: null,
      mobileApp: "",
      intercom: null,
      alarmSystem: null,
      cameras: 0,
      airCon: 0,
      recuperation: null,
      wiring: null
    }
  },
  mutations: {
    updateEmail(state, val) {
      state.email = val;
    },
    updateSecret(state, val) {
      state.secret = val;
    },
    updateConfigurationRooms(state, val) {
      state.rooms = val;
    },
    updateConfiguration(state, val) {
      state.configuration = val;
    },
    updateCalculatorData(state, val) {
      state.calculatorData = val;
    },
    updateCost(state, val) {
      state.cost = val;
    },
    updateProjectType(state, val) {
      state.data.projectType = val;
    },
    updateHomeType(state, val) {
      state.data.homeType = val;
    },
    updateSquareMeters(state, val) {
      state.data.squareMeters = val;
    },
    updateRooms(state, val) {
      state.data.rooms = val;
    },
    updateButtons(state, val) {
      state.data.buttons = val;
    },
    teButtons(state, val) {
      state.data.buttons = val;
    },
    updateDisplays(state, val) {
      state.data.displays = val;
    },
    updateVoiceControl(state, val) {
      state.data.voiceControl = val;
    },
    updateMobileApp(state, val) {
      state.data.mobileApp = val;
    },
    updateWiring(state, val) {
      state.data.wiring = val;
    },
    updateIntercom(state, val) {
      state.data.intercom = val;
    },
    updateAlarmSystem(state, val) {
      state.data.alarmSystem = val;
    },
    updateCameras(state, val) {
      state.data.cameras = val;
    },
    updateAirCon(state, val) {
      state.data.airCon = val;
    },
    updateRecuperation(state, val) {
      state.data.recuperation = val;
    }
  },
  actions: {},
  modules: {}
});
